import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TenantAdmin, CreateTenantPayload, UpdateTenantPayload } from '../interfaces/tenant-admin.interface';

@Injectable({ providedIn: 'root' })
export class TenantsAdminService {
  private baseUrl = '/api/tenants';

  constructor(private http: HttpClient) {}

  list(includeInactive: boolean = true): Observable<TenantAdmin[]> {
    return this.http.get<{ tenants: TenantAdmin[] }>(`${this.baseUrl}/`, {
      params: { include_inactive: String(includeInactive) }
    }).pipe(map(res => res.tenants));
  }

  get(id: string): Observable<TenantAdmin> {
    return this.http.get<{ tenant: TenantAdmin }>(`${this.baseUrl}/${id}`).pipe(map(res => res.tenant));
  }

  create(data: CreateTenantPayload): Observable<TenantAdmin> {
    return this.http.post<{ tenant: TenantAdmin }>(`${this.baseUrl}/`, data).pipe(map(res => res.tenant));
  }

  update(id: string, data: UpdateTenantPayload): Observable<TenantAdmin> {
    return this.http.put<{ tenant: TenantAdmin }>(`${this.baseUrl}/${id}`, data).pipe(map(res => res.tenant));
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

  uploadLogo(id: string, file: File, variant: 'small' | 'full'): Observable<TenantAdmin> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<{ tenant: TenantAdmin }>(`${this.baseUrl}/${id}/logo?variant=${variant}`, formData)
      .pipe(map(res => res.tenant));
  }
}
